import { render } from "./StudioDataLeft.vue?vue&type=template&id=ea450d12&scoped=true"
import script from "./StudioDataLeft.vue?vue&type=script&lang=js"
export * from "./StudioDataLeft.vue?vue&type=script&lang=js"

import "./StudioDataLeft.vue?vue&type=style&index=0&id=ea450d12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea450d12"]])

export default __exports__